const initialState = {
    selected_manufacturer_roles: [],
    show_gst_input: false,
    gst_details: null,
    pan_details: null,
    gst_flow: true,
    gst_number: null,
    operational_details: null,
    existingFirm: false,
    manufacturerRoleFlow: false,
    pending_role_addition_requests: []
};

const FirmOnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EXISTING_FIRM':
      return {
        ...state,
        existingFirm: action.payload
      };
    case 'SET_MANUFACTURER_ROLE_FLOW':
      return {
        ...state,
        manufacturerRoleFlow: action.payload
      };
    case 'RESET_MANUFACTURER_ROLE_FLOW':
      return {
        ...state,
        manufacturerRoleFlow: false
      };
    case 'ADD_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: [...state.selected_manufacturer_roles, action.payload]
      };
    case 'UPDATE_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: state.selected_manufacturer_roles.map(item => 
          item.manufacturer_id === action.payload.manufacturer_id ? action.payload : item
        )
      };
    case 'REMOVE_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: state.selected_manufacturer_roles.filter(
          item => item.manufacturer_id !== action.payload
        )
      };
    case 'REPLACE_MANUFACTURER_ROLES':
      return {
        ...state,
        selected_manufacturer_roles: action.payload
      };
    case 'SET_MANUFACTURER_ROLES':
      return {
        ...state,
        selected_manufacturer_roles: action.payload
      };
    case 'SET_SHOW_GST_INPUT':
      return {
        ...state,
        show_gst_input: action.payload
      };
    case 'SET_GST_FLOW':
      return {
        ...state,
        gst_flow: action.payload
      };
    case 'SET_GST_DETAILS':
      return {
        ...state,
        gst_details: action.payload
      };
    case 'SET_OPERATIONAL_DETAILS':
      return {
        ...state,
        operational_details: action.payload
      };
    case 'UPDATE_OPERATIONAL_DETAILS':
      return {
        ...state,
        operational_details: {
          ...state.operational_details,
          ...action.payload
        }
      };
    case 'SET_PAN_DETAILS':
      return {
        ...state,
        pan_details: action.payload
      };
    case 'RESET_OPERATIONAL_DETAILS': 
      return {
        ...state,
        operational_details: null
      };
    case 'RESET_PAN_DETAILS':
      return {
        ...state,
        pan_details: null
      };
    case 'SET_GST_NUMBER':
      return {
        ...state,
        gst_number: action.payload
      };
    case 'SET_PENDING_ROLE_ADDITION_REQUESTS':
      return {
        ...state,
        pending_role_addition_requests: Array.isArray(action.payload) ? action.payload : []
      };
    case 'CLEAR_PENDING_ROLE_ADDITION_REQUESTS':
      return {
        ...state,
        pending_role_addition_requests: []
      };
    case 'DEQUEUE_PENDING_ROLE_ADDITION_REQUEST':
      return {
        ...state,
        pending_role_addition_requests: state.pending_role_addition_requests.slice(1)
      };
    case 'RESET_FIRM_ONBOARDING':
      return {
        ...initialState,
        selected_firm: action.payload,
      };
    default:
      return state;
  }
};

export default FirmOnboardingReducer;
